import Axios from "axios";

// URLs resueltas por ambiente:
//   desarrollo (npm run serve) → .env.development → Lambdas DEV (QA RDS)
//   producción (npm run build) → .env.production  → API Gateway producción
const PRE_FINANCIAL_RUN_URL = process.env.VUE_APP_PRE_FINANCIAL_RUN_URL;
const FINANCIAL_RUN_URL = process.env.VUE_APP_FINANCIAL_RUN_URL;

export default {
    state: {
        financialData: {},
        loadingFinancial: false
    },
    mutations: {
        _getFinancial(state, financialData) {
            state.financialData = financialData
        },
        _clearFinancial(state) {
            state.financialData = {}
        },
        _setLoadingFinancial(state, loader){
            state.loadingFinancial = loader
        }
    },
    getters: {
        getSelectedStatusFinancial: (state) => {
            return state.financialData
        },
        getStatusLoadingFinancial: (state) => {
            return state.loadingFinancial
        }
    },
    actions: {
        async getFinancial(context, financialData) {
            context.dispatch("getLoadingFinancial", true)
            try {
              let response = await Axios.post(PRE_FINANCIAL_RUN_URL, financialData);
                    context.commit("_getFinancial", response.data)

            } catch (e) {
                // No tragarse el error: si se queda aquí, la pantalla sigue mostrando
                // la última cotización exitosa como si aplicara al lote/plazo actual.
                console.log(e);
                context.commit("_clearFinancial")
                throw e;
            }finally {
                context.dispatch("getLoadingFinancial", false)
            }
        },
        async sendFinancial(context, body) {
            return await Axios.post(FINANCIAL_RUN_URL, body);
        },
        async getLoadingFinancial(context, loader){
            context.commit("_setLoadingFinancial", loader)
        },
    }
}